import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';


@Injectable()
export class SidenavService {

  private newItemUrlPartSubject = new Subject<{ urlPart: string, params: Params }>();

  get newItemUrlPartSubscribe(): Observable<{ urlPart: string, params: Params }> { return this.newItemUrlPartSubject.asObservable(); }

  public newItemUrlPart(urlPart: string, params?: Params) {
    params = params || {};
    this.newItemUrlPartSubject.next({ urlPart, params });
  }
}
